module.exports = __webpack_public_path__ + "media/SuiteApp/assets/svg/img/selfie-a3fcb379d22eb1c219f30cc0870fc054.svg";